import React from "react";
import "./AmenitiesGMap.scss";
import { useSelector } from "react-redux";
import mapStyles from "./mapstyle.json";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import Accordion from "../Accordion/Accordion";
import { useScrollBoost } from "react-scrollbooster";

function AmenitiesGMap(props) {
  //var props.reference = useRef()the active whatever is {selected};
  var [gMap, setgMap] = useState(null);
  var [isMobile, setIsmobile] = useState(window.innerWidth);
  /*
    var [viewport, scrollBooster] = useScrollBoost({
        direction: 'all',
        scrollMode: 'native',
        onClick: (state, event) => {
            if(state.isDragging) {
                event.preventDefault();
            }
        }
    });
    */

  function isMobileCheck() {
    setIsmobile(window.innerWidth < 768);
  }

  useEffect(() => {
    isMobileCheck();
    window.addEventListener("reisze", isMobileCheck);
    return () => {
      window.addEventListener("resize", isMobileCheck);
    };
  });

  var [selected, setSelected] = useState(-1);

  var mapData = useSelector((state) => state.content.pages.area.map[0]);

  //if (selected != -1) console.log(mapData.marker_categories[selected]);

  function startMap() {
    var map = {};
    map.markers = [];
    map.map = null;

    map.createMap = function () {
      map.map = new window.google.maps.Map(props.reference.current, {
        //zoom: 15,
        zoom: 13,
        //zoom: 10,
        center: {
          //lat: 43.843503956,
          //lat: 44.85503956,
          //lat: 43.65503956,
          lat: 43.85503956,
          lng: -78.8780287,
          //lng: -79.8780287
        },
        styles: mapStyles,
      });
    };

    map.addMarkers = function (selected) {
      this.removeMarkers();
      this.markers = [];

      this.markers.push(
        this.createMarker({
          lat: parseFloat(mapData.main_pin.latitude),
          lng: parseFloat(mapData.main_pin.longitude),
          name: "",
          icon: {
            url: mapData.main_pin.icon,
            //scaledSize: new window.google.maps.Size(182, 47)
            scaledSize: new window.google.maps.Size(91, 23.5),
          },
        }),
      );

      if (selected !== -1) {
        for (
          var i = 0;
          i < mapData.marker_categories[selected].markers.length;
          i++
        ) {
          //create a marker and push that into the markers array
          this.markers.push(
            this.createMarker({
              lat: parseFloat(
                mapData.marker_categories[selected].markers[i].latitude,
              ),
              lng: parseFloat(
                mapData.marker_categories[selected].markers[i].longitude,
              ),
              label: i + 1 + "",
              name: "",
              icon: {
                url: mapData.sub_pin,
                scaledSize: new window.google.maps.Size(24, 24),
              },
            }),
          );
        }
      }
    };

    map.removeMarkers = function () {
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
    };

    map.createMarker = function (markerData) {
      var marker = new window.google.maps.Marker({
        position: {
          lat: markerData.lat,
          lng: markerData.lng,
        },
        label: markerData.label || "",
        map: this.map,
        icon: markerData.icon ? markerData.icon : "",
      });

      return marker;
    };

    map.createMap();
    return map;
  }

  function onSelectChanged(e) {
    setSelected(e.target.value);
  }

  function pauseScrolling() {}

  function resumeScrolling() {}

  //map effects
  useEffect(() => {
    if (gMap == null) {
      setgMap(startMap());
    }
  }, []);

  useEffect(() => {
    if (gMap != null) {
      gMap.addMarkers(selected);
    }
  });

  return (
    <div className="amenities-g-map">
      {typeof mapData !== "undefined" && isMobile && (
        <select
          className="mobile-category-select"
          onChange={(e) => onSelectChanged(e)}
        >
          <option value={-1}>Select Category</option>
          {mapData.marker_categories.map((cateogry, index) => (
            <option value={index} selected={index == selected}>
              {cateogry.label}
            </option>
          ))}
        </select>
      )}
      <div
        className="content-side"
        //ref={viewport}
        ref={props.canScrollRef}
      >
        <Accordion
          items={mapData.marker_categories}
          update={setSelected}
          active={selected}
          //scrollBooster={scrollBooster}
        />
      </div>
      <div
        className="map-container"
        ref={props.reference}
        onClick={(e) => e.stopPropagation()}
      ></div>
      {selected !== -1 && (
        <div className="mobile-content-side">
          <div className="mobile-content-label-heading">
            {mapData.marker_categories[selected].label}
          </div>
          <ul className="mobile-labels">
            {mapData.marker_categories[selected].markers.map((label, key) => (
              <li className="mobile-label" key={key}>
                <span className="number">{key + 1}</span>
                <span className="label">{label.name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default AmenitiesGMap;

